import { ResourceKey } from 'i18next'

const translation: ResourceKey = {
  es: {
    translation: {
      haveAnAccount: '¿Ya tienes una cuenta?',
      signIn: "Entrar",
      loginText: "Ingrese su nombre de usuario y contraseña para iniciar sesión.",
      login: 'Login',
      password: 'Contraseña',
      confirmPassword: 'Confirmar seña',
      forgotPassword: 'Olvide mi contraseña',
      signInGoogle: 'Iniciar sesión con Google',
      signInFacebook: 'Iniciar sesión con Facebook',
      noAccount: "¿No tienes una cuenta?",
      createNow: 'Crear ahora',
      portuguese: 'Portugués',
      english: 'Inglés',
      or: 'O',
      passwordPlaceholder: 'Introducir la contraseña',
      loginPlaceholder: 'CPF',
      wrongUsernameOrPassword: 'Nombre de usuario o contraseña incorrecta',

      forgotPasswordText: 'Inserte su documento para recibir un token de acceso.',
      sendToken: 'Enviar token',
      helpText1: '¿Problemas para acceder? abre el',
      chat: 'chat ',
      helpText2: 'para hablar con nuestro servicio o hablar por WhatsApp ',
      insertCodeSentTo: 'Ingrese el código enviado para',
      confirm: 'Confirmar',

      reSendCode: 'Reenviar codigo',
      sendViaEmail: 'Enviar al correo electrónico',

      hi: 'Hola, ',
      access: 'Acceso al informe',

      changeDocument: 'Cambiar documento',
      SelectDocument: 'Seleccionar un documento',
      document: 'Documento',
      createPassword: 'Crear una nueva contraseña',
      resetPassword: 'Redefinir contraseña',

      documentnotfind: 'No encontramos el documento informado',

      resetPasswordSuccess: 'Contraseña alterada con éxito',
      resetPasswordError: 'Hubo un error al registrar la nueva contraseña.',
      helperNewPassword: 'Cree una contraseña de 6 a 15 caracteres. La contraseña no puede ser la misma que su número de documento.',
      accept: 'Accepto los ',
      termsofuse: 'Terminos de Uso',
      and: ' y ',
      privacy: 'Política de Privacidad.',

      "cpf is not valid": "CPF no válido",
      "no password provided": "La contraseña es un campo requerido.",
      "User not found": "Usuario no encontrado",
      "Bad credentials": "Código no válido o caducado.",
      'token is required': 'El código es obligatorio',
      'Password is required': 'Se requiere contraseña',
      'Confirm password is required': 'La confirmación de la contraseña es obligatoria',
      'required field': 'Este campo es obligatorio',


      'PIN submission failed': '¡Hubo un error al enviar el código!',
      'Password does not match': 'Las contraseñas no coinciden',
      'the password provided cannot be the same as the document number.': 'La contraseña proporcionada no puede ser la misma que el número de documento.',
      'token generation failed': 'Hubo un error al generar el token',

      'the new password field cannot be empty': 'The new password field cannot be empty',

      espanish: 'Español',
      resentPINToken: 'El código ha sido reenviado, revise su correo electrónico y bandeja de entrada de SMS',
      birthCertificate: 'Certificado de nacimiento',
      foreignDocument: 'Documento extranjero',
      errorCertificate: 'El documento ingresado no es válido o no está registrado en nuestra base de datos. Solo los certificados emitidos después de 2010 se aceptan como inicio de sesión.',
      documentInvalid: 'El documento ingresado no es válido.',

      /* finish example block */

      /* Text report sms */

      seeResults: 'Ver mi resultado',

      registerDocument: 'Inserte el documento registrado en el momento del examen.',
      expireLink: 'Por motivos de seguridad, este enlace caduca 24 horas después de la emisión del informe. Después de este período, acceda al Portal del Paciente o descargue la aplicación Hilab para ver todos sus exámenes.',
      nDocument: 'Número del Documento',
      validDocument: 'Ingrese un CPF válido.',
      documentNotRegister: 'El documento no coincide con el registro.',
      accessReport: 'Resultado de acceso',
      documentType: 'Tipo de documento',

      goPortalPatient: 'Ir al Portal del Paciente',
      expiredOrInvalid: 'Enlace no válido o caducado.',
      youReports: 'Acceda al Portal del Paciente para ver todos sus informes.',
      portalPAtient: 'Portal del Paciente',

      donwloadApp: 'O descargue la aplicación Hilab',
      redirect: 'Un momento estamos redirigiendo...',
      errorReport: 'Hubo un error al cargar su informe.',
      verifyConnection: 'Por favor, compruebe la conexión y vuelva a intentarlo. Si el error persiste, acceda al',
      contact: 'o contacta con nuestro servicio de atención al cliente:',
      UAU: 'UAU - Unidad de atención al Usuario / Paciente',
      CNS: 'CNS (Tarjeta sanitaria nacional)',
      IssuingAgency: ' Agencia Emisora',
      state: 'Estado',

      country: 'País',
      writeCountry: 'Ingrese el país de origen',
      /* finish text report sms */

      Afghanistan: "Afganistán",
      "South Africa": "Sudáfrica",
      Albania: "Albania",
      Germany: "Alemania",
      Andorra: "Andorra",
      Angola: "Angola",
      Anguilla: "Anguila",
      Antarctic: "Antártico",
      "Antigua and Barbuda": "Antigua y Barbuda",
      "Saudi Arabia": "Arabia Saudita",
      Algeria: "Argelia",
      Argentina: "Argentina",
      Armenia: "Armenia",
      Aruba: "Aruba",
      Australia: "Australia",
      Austria: "Austria",
      Azerbaijan: "Azerbaiyán",
      Bahamas: "Bahamas",
      Bahrain: "Bahrein",
      Bangladesh: "Bangladesh",
      Barbados: "Barbados",
      Belarus: "Bielorrusia",
      Belgium: "Bélgica",
      Belize: "Belice",
      Benin: "Benin",
      Bermuda: "Bermudas",
      Bolivia: "Bolivia",
      "Bosnia Herzegovina": "Bosnia Herzegovina",
      Botswana: "Botsuana",
      Brazil: "Brasil",
      Brunei: "Brunei",
      Bulgaria: "Bulgaria",
      "Burkina fasso": "Burkina fasso",
      Burundi: "Burundi",
      Bhutan: "Bután",
      "Cape Green": "Verde de cabo",
      Cameroon: "Camerún",
      Cambodia: "Camboya",
      Canada: "Canadá",
      Canary: "Canario",
      Kazakhstan: "Kazajstán",
      "Ceuta and Melilla": "Ceuta y Melilla",
      Chad: "Chad",
      Chile: "Chile",
      China: "China",
      Cyprus: "Chipre",
      Singapore: "Singapur",
      Colombia: "Colombia",
      Consisting: "Compuesto",
      Congo: "Congo",
      "North Korea": "Corea del Norte",
      "South Korea": "Corea del Sur",
      "Costa do Marfim": "Costa do Marfim",
      "Costa Rica": "Costa Rica",
      Croatia: "Croacia",
      Cuba: "Cuba",
      Cure: "Cura",
      "Diego Garcia": "Diego garcia",
      Denmark: "Dinamarca",
      Djibouti: "Djibouti",
      Dominica: "Dominica",
      Egypt: "Egipto",
      "El Salvador": "El Salvador",
      "United Arab Emirates": "Emiratos Árabes Unidos",
      Ecuador: "Ecuador",
      Erythrean: "Eritro",
      Slovakia: "Eslovaquia",
      Slovenia: "Eslovenia",
      Spain: "España",
      "U.S": "NOSOTROS",
      Estonia: "Estonia",
      Ethiopia: "Etiopía",
      Fiji: "Fiji",
      Philippines: "Filipinas",
      Finland: "Finlandia",
      France: "Francia",
      Gabon: "Gabón",
      Gambia: "Gambia",
      Ghana: "Ghana",
      Georgia: "Georgia",
      Gibraltar: "Gibraltar",
      "Britain (United Kingdom, UK)": "Gran Bretaña (Reino Unido, Reino Unido)",
      Grenade: "Granada",
      Greece: "Grecia",
      Gyroon: "Gyroon",
      Guadalupe: "Guadalupe",
      "Guam (United States Territory)":
        "Guam (Territorio de los Estados Unidos)",
      Guatemala: "Guatemala",
      Guernsey: "Guerna",
      Guyana: "Guayana",
      "French Guiana": "Guayana francesa",
      Guinea: "Guinea",
      "Equatorial Guinea": "Guinea Ecuatorial",
      "Guinea Bissau": "Guinea Bissau",
      Haiti: "Haití",
      Netherlands: "Países Bajos",
      Honduras: "Honduras",
      "Hong Kong": "Hong Kong",
      Hungary: "Hungría",
      Yemen: "Yemen",
      Bouvet: "Bronco",
      Rise: "Subir",
      "Clipperton Island": "Isla de Clipperton",
      Island: "isla",
      "Christmas island": "Isla de Navidad",
      Pitcair: "Pitcair",
      "Island meeting": "Reunión de la isla",
      "Aland Islands": "Islas Aland",
      "Cayman Islands": "Islas Caimán",
      "Coconut islands": "Islas de Coco",
      "Cook Islands": "Islas Cook",
      "Faroe Islands": "Islas Faroe",
      "South Georgia Islands and South Sandwich":
        "Islas South Georgia y South Sandwich",
      "Heard and McDonald Islands (Australia Territory)":
        "Escuchado y McDonald Islands (Territorio de Australia)",
      Malvinas: "Malvinas",
      "Northern Mariana Islands": "Islas Marianas del Norte",
      "Marshall Islands": "Islas Marshall",
      "Smaller islands of the United States":
        "Islas más pequeñas de los Estados Unidos.",
      "Norfolk Islands": "Islas Norfolk",
      "Solomon Islands": "Islas Salomón",
      "Seychelles Islands": "Islas Seychelles",
      "Tokelau Islands": "Islas Tokelau",
      "Turks and Caicos Islands": "Islas Turcas y Caicos",
      "Virgin Islands (United States)": "Islas Vírgenes (Estados Unidos)",
      "Virgin Islands (England)": "Islas Vírgenes (Inglaterra)",
      India: "India",
      Indonesia: "Indonesia",
      Will: "Voluntad",
      Iran: "Iran",
      Iraq: "Irak",
      Ireland: "Irlanda",
      Iceland: "Islandia",
      Israel: "Israel",
      Italy: "Italia",
      Jamaica: "Jamaica",
      Japan: "Japón",
      Jersey: "Jersey",
      Jordan: "Jordán",
      Kiribati: "Kiribati",
      Kosovo: "Kosovo",
      Kuait: "Kuait",
      Laos: "Laos",
      Lesotho: "Lesoto",
      Latvia: "Letonia",
      Lebanon: "Líbano",
      Liberia: "Liberia",
      Libya: "Libia",
      Liechtenstein: "Liechtenstein",
      Lithuania: "Lituania",
      Luxembourg: "Luxemburgo",
      Macao: "Macao",
      "Macedonia (Yugoslava Republic)": "Macedonia (República Yugoslava)",
      Madagascar: "Madagascar",
      Malaysia: "Malasia",
      Malawi: "Malawi",
      Maldives: "Maldivas",
      Mali: "Mali",
      Malta: "Malta",
      Morocco: "Marruecos",
      Martinique: "Martinica",
      Maurician: "Mauricio",
      Mauritania: "Mauritania",
      Mayotte: "Macho",
      Mexico: "México",
      Micronesia: "Micronesia",
      Mozambique: "Mozambique",
      Moldovate: "Moldeado",
      Monkey: "Mono",
      Mongolia: "Mongolia",
      Montenegro: "Montenegro",
      Montserrat: "Montserrat",
      Myanma: "Myanma",
      Namibia: "Namibia",
      Nauru: "Nauru",
      Nepal: "Nepal",
      Nicaragua: "Nicaragua",
      Niger: "Níger",
      Nigeria: "Nigeria",
      Niue: "Niue",
      Norway: "Noruega",
      "New Caledonia": "Nueva Caledonia",
      "New Zealand": "Nueva Zelanda",
      Oman: "Omán",
      "Caribbean Netherlands": "Caribe Países Bajos",
      Palau: "Palau",
      Palestine: "Palestina",
      Panama: "Panamá",
      "Papua New Guinea": "Papúa Nueva Guinea",
      Pakistan: "Pakistán",
      Paraguay: "Paraguay",
      Peru: "Perú",
      "French Polynesian": "Polinesio francés",
      Poland: "Polonia",
      "Puerto Rico": "Puerto Rico",
      Portugal: "Portugal",
      Qatar: "Katar",
      Kenya: "Kenia",
      Kyrgyzstan: "Kirguistán",
      "Central African Republic": "República Centroafricana",
      "Democratic Republic of Congo": "República Democrática del Congo",
      "Dominican Republic": "República Dominicana",
      "Czech republic": "República Checa",
      Romania: "Rumania",
      Rwanda: "Ruanda",
      "Russia (former USSR) - Russian Federation":
        "Rusia (Antigua URSS) - Federación de Rusia",
      Western: "occidental",
      "Saint-Pierre and Miquelon": "Saint-Pierre y Miquelon",
      "American Samoa": "Samoa Americana",
      "Western samoa": "Samoa occidental",
      "San Marino": "San Marino",
      "Saint Helen": "San Helen",
      "Santa lúcia": "Santa Lucía",
      "São Bartolomeu": "São Bartolomeu",
      "Saint Kitts and Nevis": "Saint Kitts y Nevis",
      "São Martim": "São Martim",
      "São Martinho": "São Martinho",
      "Sao Tome and Principe": "Santo Tomé y Príncipe",
      "Saint Vincent and the Grenadines": "San Vicente y las Granadinas",
      Senegal: "Senegal",
      "Sierra Leone": "Sierra Leona",
      Serbia: "Serbia",
      Syria: "Siria",
      Somalia: "Somalia",
      "Sri Lanka": "Sri Lanka",
      Swaziland: "Swazilandia",
      Sudan: "Sudán",
      "Southern Sudan": "Sudán del sur",
      Sweden: "Suecia",
      Switzerland: "Suiza",
      Suriname: "Suriname",
      Svalbard: "Svalbard",
      Tajikistan: "Tayikistán",
      Thailand: "Tailandia",
      Taiwan: "Taiwán",
      Tanzania: "Tanzania",
      "British Indian Ocean Territory":
        "Territorio Británico del Océano Índico",
      "Territories from the south of France": "Territorios del sur de Francia.",
      "Timor-Leste": "Timor-Leste",
      Togo: "Togo",
      Tonga: "Tonga",
      "Trinidad and Tobago": "Trinidad y Tobago",
      "Tristão da Cunha": "Tristão da cunha",
      Tunisia: "Túnez",
      Turkmenistan: "Turkmenistán",
      Turkey: "Turquía",
      Tuvalu: "Tuvalu",
      Ukraine: "Ucrania",
      Uganda: "Uganda",
      Uruguay: "Uruguay",
      Uzbekistan: "Uzbekistán",
      Vanuatu: "Vanuatu",
      Vatican: "Vaticano",
      Venezuela: "Venezuela",
      Vietnam: "Vietnam",
      "Wallis and Futuna": "Wallis y Futuna",
      Zambia: "Zambia",
      Zimbabwe: "Zimbabue",
    },
  },
};

export default translation;
